<template>
    <div class="inline-flex items-center gap-2 rounded-md border px-3 py-2" :class="badgeClasses">
        <slot name="icon"></slot>
        <div class="text-sm">
            <p class="mb-0 font-medium" :class="textColor">{{ label }}</p>
            <p v-if="subtitle" class="mb-0 text-xs" :class="subtitleColor">{{ subtitle }}</p>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    label: {
        type: String,
        required: true
    },
    subtitle: {
        type: String,
        default: null
    },
    variant: {
        type: String,
        default: 'yellow',
        validator: (value) => ['yellow', 'green', 'blue'].includes(value)
    }
})

const badgeClasses = computed(() => {
    const variants = {
        yellow: 'border-yellow-700/20 bg-yellow-50',
        green: 'border-green-700/20 bg-green-50',
        blue: 'border-blue-700/20 bg-blue-50'
    }
    return variants[props.variant]
})

const textColor = computed(() => {
    const colors = {
        yellow: 'text-yellow-900',
        green: 'text-green-900',
        blue: 'text-blue-900'
    }
    return colors[props.variant]
})

const subtitleColor = computed(() => {
    const colors = {
        yellow: 'text-yellow-700',
        green: 'text-green-700',
        blue: 'text-blue-700'
    }
    return colors[props.variant]
})
</script>